export const resourceFieldPropertyDescriptor = {
    configurable: false,
    enumerable: false,
    writable: true,
};
//# sourceMappingURL=resourceFieldPropertyDescriptor.js.map